import { safeLocalStorage } from './safeStorage';

const KNOWN_NON_UTM_PARAMS = ['gclid', 'fbclid', 'gad_source', 'gbraid', 'wbraid', 'takip1'];
const CAMPAIGN_STORAGE_KEY = '__campaignParams';

let runtimeCampaignParams: Record<string, string> = {};
let runtimeInitialized = false;

function extractCampaignParamsFromSearch(search: string): Record<string, string> {
  const urlParams = new URLSearchParams(search);
  const foundParams: Record<string, string> = {};

  urlParams.forEach((value, key) => {
    if (key.startsWith('utm_') || key.startsWith('gad_') || KNOWN_NON_UTM_PARAMS.includes(key)) {
      foundParams[key] = value;
    }
  });

  return foundParams;
}

function cleanupLegacyStorage() {
  if (typeof window === 'undefined') return;
  safeLocalStorage.removeItem(CAMPAIGN_STORAGE_KEY);
}

function ensureRuntimeCampaignParams() {
  if (typeof window === 'undefined') return;
  if (runtimeInitialized) return;

  cleanupLegacyStorage();
  runtimeCampaignParams = extractCampaignParamsFromSearch(window.location.search);
  runtimeInitialized = true;
}

export function persistCampaignParamsFromURL() {
  if (typeof window === 'undefined') return;

  cleanupLegacyStorage();
  const found = extractCampaignParamsFromSearch(window.location.search);
  if (Object.keys(found).length > 0 || !runtimeInitialized) {
    runtimeCampaignParams = found;
  }
  runtimeInitialized = true;
}

export function getPersistedCampaignParams(): Record<string, string> {
  if (typeof window === 'undefined') return {};
  ensureRuntimeCampaignParams();
  return runtimeCampaignParams;
}

export function getCurrentCampaignParamsAsQueryString(): string {
  if (typeof window === 'undefined') return '';

  try {
    const data = getPersistedCampaignParams();
    const searchParams = new URLSearchParams();

    Object.entries(data).forEach(([key, value]) => {
      if (value && typeof value === 'string') {
        searchParams.set(key, value);
      }
    });

    return searchParams.toString();
  } catch {
    return '';
  }
}

export function appendCampaignParamsToUrl(inputUrl: string): string {
  if (typeof window === 'undefined') return inputUrl;

  try {
    ensureRuntimeCampaignParams();
    const persisted = getPersistedCampaignParams();
    if (!persisted || Object.keys(persisted).length === 0) return inputUrl;

    const url = new URL(inputUrl, window.location.origin);
    Object.entries(persisted).forEach(([key, value]) => {
      if (!value || typeof value !== 'string') return;
      if (!url.searchParams.has(key)) {
        url.searchParams.set(key, value);
      }
    });

    const full = url.toString();
    const origin = window.location.origin;
    return full.startsWith(origin) ? full.slice(origin.length) : full;
  } catch {
    return inputUrl;
  }
}
